import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import "./ProductPage.css";

const ProductPage = () => {
  const location = useLocation();
  const passedImagesByColor = location.state?.imagesByColor || [
    { color: "gold", images: [] },
    { color: "roseGold", images: [] },
    { color: "silver", images: [] },
  ];

  const availableKarats = location.state?.availableKarats || [];
  const availableStones = location.state?.availableStones || [];
  const productName = location.state?.name || "Product";
  const productId = location.state?.productId || "Product";
  const productWeight = location.state?.weight || "Not Available";
  const productDescription = location.state?.description || "Not Available";
  const diamondColor = location.state?.diamondColor || "Not Available";
  const numberOfDiamond = location.state?.numberOfDiamond || "Not Available";
  const diamondCutGrade = location.state?.diamondCutGrade || "Not Available";
  const diamondShape = location.state?.diamondShape || "Not Available";
  const diamondType = location.state?.diamondType || "Not Available";
  const sideDiamondColor = location.state?.sideDiamondColor || "Not Available";
  const numberOfSideDiamond =
    location.state?.numberOfSideDiamond || "Not Available";
  const sideDiamondShape = location.state?.sideDiamondShape || "Not Available";
  const sideDiamondCutGrade =
    location.state?.sideDiamondCutGrade || "Not Available";
  const sideDiamondType = location.state?.sideDiamondType || "Not Available";
  const stonePieces = location.state?.stonePieces || "Not Available";
  const stoneColor = location.state?.stoneColor || "Not Available";
  const stoneType = location.state?.stoneType || "Not Available";
  const stoneShape = location.state?.stoneShape || "Not Available";
  const stoneWeight = location.state?.stoneWeight || "Not Available";
  const price10k = location.state?.price10k || "Not Available";
  const price14k = location.state?.price14k || "Not Available";
  const price18k = location.state?.price18k || "Not Available";
  const discountedPrice10k =
    location.state?.discountedPrice10k || "Not Available";
  const discountedPrice14k =
    location.state?.discountedPrice14k || "Not Available";
  const discountedPrice18k =
    location.state?.discountedPrice18k || "Not Available";

  const filteredImagesByColor = passedImagesByColor.filter(
    (colorGroup) =>
      Array.isArray(colorGroup.images) && colorGroup.images.length > 0
  );

  const [imagesByColor, setImagesByColor] = useState(filteredImagesByColor);
  const [selectedColor, setSelectedColor] = useState(
    filteredImagesByColor[0] || { color: "", images: [] }
  );

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedKarat, setSelectedKarat] = useState("");
  const [selectedStone, setSelectedStone] = useState("");
  const [selectedSize, setSelectedSize] = useState("");

  const handleAddToCart = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please log in to add items to your cart.");
      return;
    }

    if (!selectedSize) {
      alert("Please select a size.");
      return;
    }

    const productData = {
      productId,
      name: productName,
      color: selectedColor.color,
      size: selectedSize,
      karat: selectedKarat,
      stone: selectedStone,
      price: getCurrentDiscountedPrice(),
      originalPrice: getCurrentPrice(),
      image: selectedColor.images[currentImageIndex],
      quantity: 1,
    };

    try {
      const response = await fetch("https://backend.rubiajewels.com/api/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(productData),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message);
      } else {
        alert(result.message || "Failed to add to cart.");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const sizes = [
    "3",
    "3.25",
    "3.5",
    "3.75",
    "4",
    "4.25",
    "4.5",
    "4.75",
    "5",
    "5.25",
    "5.5",
    "5.75",
    "6",
    "6.25",
    "6.5",
    "6.75",
    "7",
    "7.25",
    "7.5",
    "7.75",
    "8",
    "8.25",
    "8.5",
    "8.75",
    "9",
    "9.25",
    "9.5",
    "9.75",
    "10",
    "10.25",
    "10.5",
    "10.75",
    "11",
    "11.25",
    "11.5",
    "11.75",
    "12",
    "12.25",
    "12.5",
    "12.75",
    "13",
    "13.25",
    "13.5",
    "13.75",
    "14",
    "14.25",
    "14.5",
    "14.75",
    "15",
    "15.25",
    "15.5",
    "15.75",
    "16",
  ];

  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  useEffect(() => {
    const filteredColors = passedImagesByColor.filter(
      (colorGroup) =>
        Array.isArray(colorGroup.images) && colorGroup.images.length > 0
    );
    setImagesByColor(filteredColors);
    setSelectedColor(filteredColors[0] || { color: "", images: [] });
    setCurrentImageIndex(0);
  }, [location.state]);

  const handleColorChange = (colorIndex) => {
    const newColor = imagesByColor[colorIndex];
    if (newColor) {
      setSelectedColor({
        ...newColor,
        images: newColor.images || [],
      });
      setCurrentImageIndex(0);
    }
  };

  const handleNextImage = () => {
    if (selectedColor.images.length > 0) {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % selectedColor.images.length
      );
    }
  };

  const handlePrevImage = () => {
    if (selectedColor.images.length > 0) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? selectedColor.images.length - 1 : prevIndex - 1
      );
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNextImage,
    onSwipedRight: handlePrevImage,
    preventScrollOnSwipe: true,
  });

  const getCurrentPrice = () => {
    switch (selectedKarat) {
      case "10k":
        return price10k;
      case "14k":
        return price14k;
      case "18k":
        return price18k;
      default:
        return 0;
    }
  };

  const getCurrentDiscountedPrice = () => {
    switch (selectedKarat) {
      case "10k":
        return discountedPrice10k;
      case "14k":
        return discountedPrice14k;
      case "18k":
        return discountedPrice18k;
      default:
        return 0;
    }
  };
  useEffect(() => {
    if (availableKarats.length > 0) {
      setSelectedKarat(availableKarats[0]);
    }
  }, [availableKarats]);
  // console.log("location.state:", location.state);
  // console.log("availableKarats:", location.state?.availableKarats);

  return (
    <div className="product-container">
      <div className="product-left hidden">
        {selectedColor.images.length > 0 ? (
          <div className="image-grid">
            {selectedColor.images[0] && (
              <img
                src={`https://backend.rubiajewels.com/${selectedColor.images[0]}`}
                alt="Product Image 1"
                className="full-width-image"
              />
            )}

            <div className="two-column">
              {selectedColor.images[1] && (
                <img
                  src={`https://backend.rubiajewels.com/${selectedColor.images[1]}`}
                  alt="Product Image 2"
                  className="half-width-image"
                />
              )}
              {selectedColor.images[2] && (
                <img
                  src={`https://backend.rubiajewels.com/${selectedColor.images[2]}`}
                  alt="Product Image 3"
                  className="half-width-image"
                />
              )}
            </div>

            <div className="two-column">
              {selectedColor.images[3] && (
                <img
                  src={`https://backend.rubiajewels.com/${selectedColor.images[3]}`}
                  alt="Product Image 4"
                  className="half-width-image"
                />
              )}
              {selectedColor.images[4] && (
                <img
                  src={`https://backend.rubiajewels.com/${selectedColor.images[4]}`}
                  alt="Product Image 5"
                  className="half-width-image"
                />
              )}
            </div>
          </div>
        ) : (
          <p>No images available</p>
        )}
      </div>

      <div className="product-left visible">
        <div className="main-slider" {...swipeHandlers}>
          {/* <button className="nav-btn prev" onClick={handlePrevImage}>
            &#10094;
          </button> */}
          {selectedColor.images.length > 0 ? (
            <img
              src={`https://backend.rubiajewels.com/${selectedColor.images[currentImageIndex]}`}
              alt={`Product Image ${currentImageIndex + 1}`}
              className="main-image"
            />
          ) : (
            <p>No images available</p>
          )}
          {/* <button className="nav-btn next" onClick={handleNextImage}>
            &#10095;
          </button> */}
        </div>

        <div className="thumbnail-slider">
          {selectedColor.images.map((image, index) => (
            <img
              key={index}
              src={`https://backend.rubiajewels.com/${image}`}
              alt={`Thumbnail ${index + 1}`}
              className={`thumbnail ${
                currentImageIndex === index ? "active" : ""
              }`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </div>

      <div className="product-right">
        <h2>{productName}</h2>
        <h4 className="product-color-h4">
          Price : <del>₹{getCurrentPrice()}</del> ₹{getCurrentDiscountedPrice()}
        </h4>
        <h4>Product Weight : {productWeight} Gram</h4>

        <hr className="product-hr" />

        <h4 className="product-color-h4">Select Metal :</h4>
        <div className="carat-buttons">
          {availableKarats.includes("18k") && (
            <button
              className={selectedKarat === "18k" ? "active" : ""}
              onClick={() => setSelectedKarat("18k")}
            >
              18K
            </button>
          )}
          {availableKarats.includes("14k") && (
            <button
              className={selectedKarat === "14k" ? "active" : ""}
              onClick={() => setSelectedKarat("14k")}
            >
              14K
            </button>
          )}
          {availableKarats.includes("10k") && (
            <button
              className={selectedKarat === "10k" ? "active" : ""}
              onClick={() => setSelectedKarat("10k")}
            >
              10K
            </button>
          )}
        </div>

        {availableStones.length > 0 && (
          <>
            <hr className="product-hr" />
            <h4 className="product-color-h4">Select Stones :</h4>
            <div className="carat-buttons">
              {availableStones.includes("Mother-of-pearl") && (
                <button
                  className={
                    selectedStone === "Mother-of-pearl" ? "active" : ""
                  }
                  onClick={() => setSelectedStone("Mother-of-pearl")}
                >
                  Mother-of-pearl
                </button>
              )}
              {availableStones.includes("Malachite") && (
                <button
                  className={selectedStone === "Malachite" ? "active" : ""}
                  onClick={() => setSelectedStone("Malachite")}
                >
                  Malachite
                </button>
              )}
              {availableStones.includes("Tiger-Eye") && (
                <button
                  className={selectedStone === "Tiger-Eye" ? "active" : ""}
                  onClick={() => setSelectedStone("Tiger-Eye")}
                >
                  Tiger-Eye
                </button>
              )}
              {availableStones.includes("Onyx") && (
                <button
                  className={selectedStone === "Onyx" ? "active" : ""}
                  onClick={() => setSelectedStone("Onyx")}
                >
                  Onyx
                </button>
              )}
              {availableStones.includes("Turquoise") && (
                <button
                  className={selectedStone === "Turquoise" ? "active" : ""}
                  onClick={() => setSelectedStone("Turquoise")}
                >
                  Turquoise
                </button>
              )}
              {availableStones.includes("Diamond") && (
                <button
                  className={selectedStone === "Diamond" ? "active" : ""}
                  onClick={() => setSelectedStone("Diamond")}
                >
                  Diamond
                </button>
              )}
            </div>
          </>
        )}

        <hr className="product-hr" />
        <h4 className="product-color-h4">Select Color :</h4>
        <div className="product-color-buttons">
          {imagesByColor.map((colorGroup, index) => (
            <button
              key={index}
              className={`product-color-button ${
                selectedColor.color === colorGroup.color ? "active" : ""
              }`}
              onClick={() => handleColorChange(index)}
              style={{
                background:
                  colorGroup.color === "gold"
                    ? "linear-gradient(227deg, rgb(217, 180, 52) 0%, rgb(254, 246, 210) 37%, rgb(224, 201, 98) 100%)"
                    : colorGroup.color === "roseGold"
                    ? "linear-gradient(227deg, rgb(235, 202, 185) 0%, rgb(253, 239, 232) 37%, rgb(230, 190, 168) 100%)"
                    : "linear-gradient(227deg, rgb(160, 160, 160) 0%, rgb(240, 240, 240) 37%, rgb(186, 185, 185) 100%)",
              }}
            />
          ))}
        </div>
        <hr className="product-hr" />

        <div className="size-selector">
          <h4>Select Size :</h4>
          <select
            className="size-dropdown"
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
          >
            <option value="" disabled>
              Choose a size
            </option>
            {sizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        <button className="add-to-bag" onClick={handleAddToCart}>
          ADD TO BAG
        </button>
        <section className="faq-container">
          <div className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleSection("faqs")}
            >
              Diamond Details
              <span className="faq-toggle">
                {activeSection === "faqs" ? "−" : "+"}
              </span>
            </button>
            <div
              className={`faq-answer ${activeSection === "faqs" ? "show" : ""}`}
            >
              <ul className="faq-ul">
                <li>Diamond Color : {diamondColor} </li>
                <li>Number Of Diamond : {numberOfDiamond} </li>
                <li>Diamond Cut Grade : {diamondCutGrade}</li>
                <li>Diamond Shape : {diamondShape}</li>
                <li>Diamond Type : {diamondType}</li>
                <li>Description : {productDescription} </li>
              </ul>
            </div>
          </div>

          <div className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleSection("care")}
            >
              Side Diamond Details
              <span className="faq-toggle">
                {activeSection === "care" ? "−" : "+"}
              </span>
            </button>
            <div
              className={`faq-answer ${activeSection === "care" ? "show" : ""}`}
            >
              <ul className="faq-ul">
                <li>Side Diamond Color : {sideDiamondColor}</li>
                <li>Number Of Side Diamond : {numberOfSideDiamond}</li>
                <li>Side Diamond Shape : {sideDiamondShape}</li>
                <li>Side Diamond Cut Grade : {sideDiamondCutGrade}</li>
                <li>Side Diamond Type : {sideDiamondType}</li>
              </ul>
            </div>
          </div>

          <div className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleSection("stone")}
            >
              Stone Details
              <span className="faq-toggle">
                {activeSection === "stone" ? "−" : "+"}
              </span>
            </button>
            <div
              className={`faq-answer ${
                activeSection === "stone" ? "show" : ""
              }`}
            >
              <ul className="faq-ul">
                <li>Stone Color : {stoneColor}</li>
                <li>Number Of Stones : {stonePieces}</li>
                <li>Stone Shape : {stoneShape}</li>
                <li>Stone Type : {stoneType}</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProductPage;
